<script>
import api from '@/command/api'
import apiTool from '@/command/apiTool'
import DrawerForm from '../../../components/DrawerForm'
import TemplateHeaderTable from '../../../components/TemplateHeaderTable'
import moment from 'moment'
import { getAction } from '@/command/netTool'

export default {
  name: 'balanceRechargeCard',
  data() {
    return {
      ...api.command.getState(),
      paramsValue: {
        balanceType: '1',
      },
      mergeBalanceList: [],
    }
  },
  mounted() {
    getAction('/api/farmBalance/relationList').then((res) => {
      if (res.code == 200) {
        this.mergeBalanceList = res.data.map((e) => {
          return {
            ...e,
            name: e.name,
            value: e.id,
          }
        })
        this.$forceUpdate()
      }
    })
    api.command.getList.call(this, {
      url: '/farmBalance/list',
      current: 1,
    })
  },
  methods: {
    getHeader() {
      return [
        {
          name: '充值卡名称',
          key: 'name',
          type: 'input',
        },
        {
          type: '',
        },
      ]
    },
    getColumns() {
      return [
        {
          dataIndex: 'id',
          title: 'ID',
          align: 'left',
          sorter: (a, b) => a.id - b.id,
        },
        {
          dataIndex: 'name',
          title: '充值卡名称',
          align: 'left',
        },
        {
          dataIndex: 'amount',
          title: '金额',
          align: 'left',
        },
        {
          dataIndex: 'mergeBalanceId',
          title: '关联卡券',
          align: 'left',
          customRender: (text, record) => {
            const obj = this.mergeBalanceList.find((e) => e.id == text) || {}
            return [obj.areaName, obj.name].filter((e) => e).join('/')
          },
        },
        {
          dataIndex: 'action',
          title: '操作',
          type: 'buttonGroup',
          align: 'center',
          width: '10%',
          typeData: ({ records }) => {
            return [
              {
                name: '编辑',
                onClick: () => {
                  this.$router.push({
                    path: '/marketingCenter/balanceRechargeCardDetail',
                    query: {
                      id: records.id,
                    },
                  })
                },
              },
              {
                name: '删除',
                type: 'pop',
                popTitle: '确认是否删除吗?',
                onClick: () => {
                  api.command.del.call(this, {
                    url: '/farmBalance/del',
                    params: {
                      id: records.id,
                    },
                  })
                },
              },
            ]
          },
        },
      ]
    },
    getButton() {
      return [
        {
          name: '添加',
          type: 'primary',
          icon: 'plus',
          onClick: () => {
            this.$router.push({
              path: '/marketingCenter/balanceRechargeCardDetail',
            })
          },
        },
      ]
    },
  },
  render() {
    return (
      <TemplateHeaderTable
        headerData={this.getHeader()}
        tableColumns={this.getColumns()}
        button={this.getButton()}
        records={this.records}
      />
    )
  },
}
</script>
